






















import { Component, Prop } from 'vue-property-decorator';
import { ITag, TagCategory } from 'admiral-core';
import 'dayjs/locale/de';
import { mixins } from 'vue-class-component';
import { FormatMixin } from '@/mixins/FormatMixin';
import Multiselect from 'vue-multiselect';
import { TagApi } from '@/services/TagApi';
import { BaseMixin } from '@/mixins/BaseMixin';

@Component({
  name: 'tag-select',
  components: { Multiselect },
})
export default class TagSelect extends mixins(BaseMixin, FormatMixin) {
  @Prop({ type: Array, required: false })
  availableTags!: ITag[];

  @Prop({ type: Array, required: true })
  selectedTags!: ITag[];

  @Prop({ type: Boolean, default: () => true })
  multiple!: boolean;

  @Prop({ type: Boolean, default: () => true })
  taggable!: boolean;

  @Prop({ type: Number, default: () => TagCategory.Tasks })
  category!: TagCategory;

  get options() {
    return this.availableTags || this.$store.state.DataModule.tags || [];
  }

  get filteredOptions() {
    return this.options.filter((tag: ITag) => tag.category === this.category);
  }

  get placeholder() {
    return this.taggable ? 'Tags wählen oder hinzufügen' : 'Tags wählen';
  }

  async loadTags() {
    const response = await TagApi.getTags({
      agency: this.user.agency,
    });
    this.availableTags = response.data;
  }

  async addTag(name: string) {
    const tagName = name.replace('#', '');

    console.log('addTag');
    const existingTag = this.options.find((tag: ITag) => tag.name === tagName);
    console.log(existingTag);
    if (existingTag) {
      const tags = [...this.selectedTags, existingTag];
      this.updateTagSelection(tags);
      return;
    }

    try {
      const response = await TagApi.create({
        tag: {
          name: tagName,
          category: this.category,
        },
      });

      const newTag = response.data;

      const tags = [...this.selectedTags, newTag];

      const availableTags = [...this.options, newTag];

      this.$store.commit('DataModule/updateTags', availableTags);

      this.updateTagSelection(tags);
    } catch (e) {
      console.log(e);
    }
  }

  updateTagSelection(tags: ITag | ITag[]) {
    this.$emit('update-tags', Array.isArray(tags) ? tags : [tags]);
  }
  label(tag: ITag) {
    return `#${tag.name}`;
  }
}
